import { useAnalytics } from "@hooks/useAnalytics";
import { useApp } from "@hooks/useApp";
import { type ComponentProps } from "@ts/components";
import { type Article } from "@ts/sanity";
import React, { type FC } from "react";

type ArticleInputProps = ComponentProps & {
  previous?: Article;
  next?: Article;
};

type ArticleOutputProps = ArticleInputProps & {
  routes: Record<string, string>;
  handleClick: (type: string, id: string) => () => void;
};

export const withArticleFooter =
  (Component: FC<ArticleOutputProps>) =>
  ({ name = "ArticleFooter", previous, next }: ArticleInputProps) => {
    const {
      config: {
        settings: { routes },
      },
    } = useApp();

    const { trackClick } = useAnalytics();

    const handleClick = (type: string, url: string) => () => {
      trackClick(type, url);
    };

    Component.displayName = name;
    return (
      <Component
        previous={previous}
        next={next}
        routes={routes}
        handleClick={handleClick}
      />
    );
  };
